import React, { Component } from 'react'
import { SubTab, SubTabs } from '../../../components/layout'
import AssessorParticipants from './AssessorParticipants'
import { apiParticipants } from 'helpers/decorators/api'

@apiParticipants({
    assessorActivityParticipants: true,
    assessorAJParticipants: true,
    assessorRPParticipants: true
})
class AssessorParticipantsDetail extends Component {
  render() {
    return (
        <div>
            <SubTabs>
                <SubTab
                    title="Activity"
                    intlKey="assessor.participant_activity"
                >
                    <AssessorParticipants isAssessorActivityParticipants {...this.props} />
                </SubTab>
                <SubTab
                    title="Adventurous journeys"
                    intlKey="assessor.participant_aj"
                >
                    <AssessorParticipants isAssessorAJParticipants {...this.props} />
                </SubTab>
                <SubTab
                    title="Residential Project"
                    intlKey="assessor.participant_rp"
                 >
                    <AssessorParticipants isAssessorRPParticipants {...this.props} />
                </SubTab>
            </SubTabs>
        </div>
    )
  }
}

export default AssessorParticipantsDetail
